import type { IV1GetBuildingCategoryOffersResponse } from 'shared/repositories/commercial-buildings/entities/entities/V1GetBuildingCategoryOffersResponse';
import type { ICategoryOffers } from 'shared/types/buildingOffers';

export const mapResponse200 = ({ offers, offersCount }: IV1GetBuildingCategoryOffersResponse): ICategoryOffers => ({
  offersCount,
  offers: offers.map(offer => ({
    cianId: offer.cianId,
    category: offer.category,
    price: offer.price ?? null,
    totalArea: offer.totalArea ?? null,
    floorNumber: offer.floorNumber ?? null,
    floorsCount: offer.floorsCount ?? null,
    conditionType: offer.conditionType ?? null,
    ceilingHeight: offer.ceilingHeight ?? null,
    hasFurniture: offer.hasFurniture ?? null,
    isOccupied: offer.isOccupied ?? null,
    photos: offer.photos.map(({ fullUrl }) => fullUrl).filter(Boolean),
    phones: offer.phones.map(({ countryCode, number }) => ({ countryCode, number })),
    url: offer.titleLink,
  })),
});
